var rtl_rtlignore_default = {
  "rtl": "PDLHe",
  "ltr": "Ez5Rv"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
